export const CATEGORY_CONTENT_FIELDS = {
  title: {
    key: 'title',
    label: 'title',
    uploadLabel: 'title',
    currentField: 'meta_title',
    suggestedField: 'suggested_title',
    payloadField: 'metaTitle',
    loadingKey: 'bulkTitleUpload'
  },
  description: {
    key: 'description',
    label: 'text',
    uploadLabel: 'text',
    currentField: 'category_description',
    suggestedField: 'suggested_description',
    payloadField: 'description',
    loadingKey: 'bulkDescriptionUpload'
  }
}

export const getCategoryContentField = (field) => CATEGORY_CONTENT_FIELDS[field] || null
